import { Component, OnInit } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { ActionNotification } from '../../../models/notification/action-notification.model'
import { ActionNotificationService } from '../../../services/notification/action-notification.service';
import { Customer } from '../../../models/customer/customer-model'
import { CustomerService } from '../../../services/customer/customer.service';

@Component({
    selector: 'app-edit-action-notification',
    templateUrl: './edit-action-notification.component.html',
    styleUrls: ['./edit-action-notification.component.css']
})
/** edit-action-notification component*/
export class EditActionNotificationComponent {
  public notification = new ActionNotification();
  public customerList: Customer[];
  public htmlContent: any;
    /** edit-action-notification ctor */
  constructor(
    private _avRoute: ActivatedRoute,
    private readonly actionNotificationService: ActionNotificationService,
    private readonly customerService: CustomerService, private _router: Router) {
    this.getVendors();
    if (this._avRoute.snapshot.params["id"]) {
      this.getActionNotificationById(this._avRoute.snapshot.params["id"]);
    }
  }

  getVendors() {
    this.customerService.getVendorsList().subscribe(
      data => {
        this.customerList = data;
      }
    )
  }

  getActionNotificationById(id: string) {
    this.actionNotificationService.GetActionNotificationById(id).subscribe(
      data => {
        this.notification = data;
        this.htmlContent = this.notification.notificationDetail;
      }
    )
  }
  //onContentChange(html: string): void {
  //  this.notification.notificationDetail = html;
  //}

  onSubmit() {
    this.notification.notificationDetail = this.htmlContent;
    this.actionNotificationService.UpdateActionNotification(this.notification);
  }

}



// WEBPACK FOOTER //
// ./src/app/notification-components/action-based-notifications/edit-action-notification/edit-action-notification.component.ts